export class CostReviewAfms {
  numberOfAfms!: number;
  manufacturer!: string;
  applications!: number[];
  afmsSchedule!: number;
  unitsDevicesFurnishedBy!: number;
  unitsDevicesInstalledBy!: number;
  unitsDevicesWiredBy!: number;
  isAfmsApplicable!: boolean;
}
